import { createContext, ElementType } from 'react';
import { NextgenImageProviderInterface } from './types/propsTypes';

interface ContextInterface {
  element: ElementType;
  useCDNForCS: boolean;
}

const NextgenImageContext = createContext<ContextInterface>({} as ContextInterface);

const NextgenImageProvider = ({ element, children, useCDNForCS = false }: NextgenImageProviderInterface) => (
  <NextgenImageContext.Provider value={{ element, useCDNForCS }}>{children}</NextgenImageContext.Provider>
);

export { NextgenImageProvider, NextgenImageContext };
